<template>
  <div>
    <recipient v-if="schema.recipient" :model="schema.recipient" />

    <div class="mt-2">
      <w-wysiwyg :model="schema.content" :config="wyswigConfig" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Recipient from './components/Recipient';

// @vuese
// Formularz dokumentu ogólnego
// @group ActionData
export default {
  components: { ...components, Recipient },
  props: {
    // schema
    schema: { type: Object, required: true }
  },
  data() {
    return {
      wyswigConfig: { allowedContent: true, height: 450 }
    };
  }
};
</script>
